<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      showEdit
      @edit='openEdit'
    >
      <v-card-text>
        <span
          v-if='!project.project_detail.fertilizer_field_instructions'
          :class='project.project_detail.fertilizer ? "" : "font-italic text--disabled font-weight-thin"'
        >
          {{ project.project_detail.fertilizer ? 'None...' : '(Fertilizer not selected)'}}
        </span>
        <span v-html='project.project_detail.fertilizer_field_instructions'></span>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :title='title'
      :icon='icon'
      :iconColor='iconColor'
      :showDialog='showDialog'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-textarea
        outlined
        auto-grow
        v-model='projectCopy.project_detail.fertilizer_field_instructions'
        hint='this will only appear on fertilizer/weed control work orders'
        persistent-hint
      ></v-textarea>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'fertilizer-field-instructions',
  props: {
    project: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    title: 'Fertilizer Field Instructions',
    icon: 'mdi-sprout',
    iconColor: 'success',
    projectCopy: { project_detail: {} },
    showDialog: false
  }),
  methods: {
    openEdit () {
      this.projectCopy = _.cloneDeep(this.project)
      this.showDialog = true
    },
    save () {
      this.$emit('update', this.projectCopy)
      this.showDialog = false
    }
  }
}
</script>